module.exports = __webpack_public_path__ + "img/video_submit.1b50a8da.png";